import React from 'react';
import Report from '@peoplenet/vi-components-ui/src/report/container/Report';

const report = () => {
  return (
    <div className="bodycontent">
      <Report />
    </div>
  );
};

export default report;
